import React from 'react';
import PropTypes from 'prop-types';

import deburr from 'lodash/deburr';
import includes from 'lodash/includes';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

const renderInputComponent = (inputProps) => {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      variant="outlined"
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}

const styles = theme => ({
  root: {
    height: 120,
    flexGrow: 1,
    marginTop: 20,
  },
  container: {
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    maxHeight: 280,
    overflowY: 'auto'
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
});

let popperNode;

class ItemAutocomplete extends React.Component {
  state = {
    popper: '',
    suggestions: [],
  };
  
  getSuggestions = (data, value) => {
    const inputValue = deburr(value.trim()).toLowerCase();
    return data.filter(i => includes(i.productData.name.toLowerCase(), inputValue) || includes(i.productData.subname.toLowerCase(), inputValue));
  }
  
  getSuggestionValue = (suggestion) => {
    const { handleAddItem } = this.props;
    handleAddItem(suggestion);
    return suggestion.productData.name + ', ' + suggestion.productData.subname;
  }

  handleSuggestionsFetchRequested = ({ value }) => {
    const { data } = this.props;
    this.setState({
      suggestions: this.getSuggestions(data, value),
    });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  handleChange = name => (event, { newValue }) => {
    this.setState({
      [name]: newValue,
    });
  };

  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    let { discount } = this.props;
    discount = parseInt(discount);
    const suggestionLabel = suggestion.productData.name + ', ' + suggestion.productData.subname;
    const matches = match(suggestionLabel, query);
    const parts = parse(suggestionLabel, matches);

    let pack = '';
    if (!suggestion.isBulk) {
      const packrow = suggestion.packrows[0];
      pack = packrow.count + ' ' + packrow.uom + ' ' +  packrow.pack;
    }
    const availableQuantity = (<span><span style={{ textDecorationColor: 'red', color: 'red' }}>{Math.trunc(suggestion.availableQuantity)}</span>&nbsp;<i>left</i></span>);
    const price = (<span><span style={{ textDecoration: 'line-through', textDecorationColor: 'red' }}>${parseFloat(suggestion.price).toFixed(2)}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${(parseFloat(suggestion.price) * (1 - (discount / 100))).toFixed(2)}</span>);

    return (
      <MenuItem selected={isHighlighted} component="div" style={{ height: 48, flexDirection: 'column' }}>
        <Grid container spacing={0} justify="space-between">
          <Grid item md={6}>
            <div style={{ fontSize: '12px', wordWrap: 'break-word' }}>
              {parts.map((part, index) =>
                part.highlight ? (
                  <span key={String(index)} style={{ fontWeight: 500, backgroundColor: '#4196f2', color: '#fff' }}>
                    {part.text}
                  </span>
                ) : (
                  <strong key={String(index)} style={{ fontWeight: 300 }}>
                    {part.text}
                  </strong>
                )
              )}
            </div>
          </Grid>
          <Grid item md={2}><div style={{fontSize: '12px', display: 'flex', justifyContent: 'center'}}>{availableQuantity}</div></Grid>
          <Grid item md={2}><div style={{fontSize: '12px', display: 'flex', justifyContent: 'center'}}>{pack}</div></Grid>
          <Grid item md={2}><div style={{fontSize: '12px', display: 'flex', justifyContent: 'flex-end' }}>{price}</div></Grid>
        </Grid>
        <Grid container spacing={0} justify="space-between">
          <Grid item md={6}>
            <div style={{fontSize: '10px', wordWrap: 'break-word', color: '#5f89b3'}}>
              {suggestion.productData.category}
            </div>
          </Grid>
          <Grid item md={6}><div style={{fontSize: '10px', color: '#5f89b3', display: 'flex', justifyContent: 'flex-end' }}>{suggestion.sourcename}</div></Grid>
        </Grid>
      </MenuItem>
    );
  }

  render() {
    const { classes } = this.props;

    const autosuggestProps = {
      renderInputComponent,
      suggestions: this.state.suggestions,
      onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
      getSuggestionValue: this.getSuggestionValue,
      renderSuggestion: this.renderSuggestion,
    };

    return (
      <div className={classes.root}>
        <Autosuggest
          {...autosuggestProps}
          inputProps={{
            classes,
            label: 'Name',
            placeholder: 'Search item',
            value: this.state.popper,
            onChange: this.handleChange('popper'),
            inputRef: node => {
              popperNode = node;
            },
            InputLabelProps: {
              shrink: true,
            },
          }}
          theme={{
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
          }}
          renderSuggestionsContainer={options => (
            <Popper anchorEl={popperNode} open={Boolean(options.children)}>
              <Paper
                square
                {...options.containerProps}
                style={{ width: popperNode ? popperNode.clientWidth : null }}
              >
                {options.children}
              </Paper>
            </Popper>
          )}
        />
      </div>
    );
  }
}

ItemAutocomplete.propTypes = {
  classes: PropTypes.shape({}).isRequired,
};

export default withStyles(styles)(ItemAutocomplete);
